var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7949 10.5V6.75C16.7949 5.55653 16.3208 4.41193 15.4769 3.56802C14.633 2.72411 13.4884 2.25 12.2949 2.25C11.1014 2.25 9.95686 2.72411 9.11294 3.56802C8.26903 4.41193 7.79492 5.55653 7.79492 6.75V10.5M7.04492 21.75H17.5449C18.1417 21.75 18.714 21.5129 19.1359 21.091C19.5579 20.669 19.7949 20.0967 19.7949 19.5V12.75C19.7949 12.1533 19.5579 11.581 19.1359 11.159C18.714 10.7371 18.1417 10.5 17.5449 10.5H7.04492C6.44818 10.5 5.87589 10.7371 5.45393 11.159C5.03197 11.581 4.79492 12.1533 4.79492 12.75V19.5C4.79492 20.0967 5.03197 20.669 5.45393 21.091C5.87589 21.5129 6.44818 21.75 7.04492 21.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ac01d57b3ed679660a354d9dc1501086.svg";
export { ForwardRef as ReactComponent };